/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-17, 09:39:21
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-25, 15:05:59
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

// Vuex Payment module main file

import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  tokenIsValid: false,
  gatewayUrl: undefined,
  selectedGateway: undefined,
  isWaitingForRedirectionToPaymentGateway: false,
  isWaitingForSaleServicePointData: true,
  canSubmitPayment: false,
  creditCardData: {
    firstName: null,
    lastName: null,
    email: null,
    number: null,
    cvv: null,
    expirationYear: null,
    expirationMonth: null,
  },
  params: {
    total_amount: 0,
    currency: 'PLN',
    description: '',
    redirect_after_pay: null,
    lang: 'pl',
    products: [],
  },
  saleServicePoint: {
    uuid: null,
    name: '',
    gateways: [],
    brand: {},
  },
};

const getters = {
  tokenIsValid: state => state.tokenIsValid,
  paymentLanguage: state => state.params.lang,
  paymentProducts: state => state.params.products,
  paymentDescription: state => state.params.description,
  paymentCurrency: state => String(state.params.currency).toUpperCase(),
  paymentTotalAmount: state => Number(state.params.total_amount),
  saleServicePointGateway: state => state.saleServicePoint.gateways,
  saleServicePointUuid: state => state.saleServicePoint.uuid,
  gatewayUrl: state => state.gatewayUrl,
  isWaitingForRedirectionToPaymentGateway: state => state.isWaitingForRedirectionToPaymentGateway,
  isWaitingForSaleServicePointData: state => state.isWaitingForSaleServicePointData,
  selectedGateway: state => state.selectedGateway,
  canSubmitPayment: state => state.canSubmitPayment,
  brandLogo: state => state.saleServicePoint.brand.logo,
  brandColors: state => ({
    main: state.saleServicePoint.brand.main_color || '#33691e',
    accent: state.saleServicePoint.brand.accent_color || '#7cb342',
    summary_text: state.saleServicePoint.brand.payment_summary_text_color || '#ffffff',
  }),
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;



// WEBPACK FOOTER //
// ./src/store/modules/Payment/index.js